import { Icon, makeStyles } from '@rneui/themed'

const DEFAULT_SIZE = 24

export function GoldStar({ size }: { size?: number }) {
  const styles = useStyles()
  return (
    <Icon
      name="star"
      color={styles.goldColor.color}
      size={size ?? DEFAULT_SIZE}
    />
  )
}

const useStyles = makeStyles(() => ({
  goldColor: {
    color: '#FFD700',
  },
}))
